import { ListBullets } from "@phosphor-icons/react";
import { phaseRegistry } from "../registry.js";
import { PhaseTile } from "../components.js";
import { ItemTable } from "../table.js";

const BacklogPage = () => {
  return <ItemTable search="phase:backlog" />;
};

const BacklogTile = () => {
  return (
    <PhaseTile phase="backlog">
      <ListBullets size={24} />
    </PhaseTile>
  );
};

phaseRegistry.register({
  type: "backlog",
  order: 4,
  page: BacklogPage,
  tile: BacklogTile,
});
